<template>
  <div class="about">
    <Banner :classType="1" />
    <Menu :lang="lang" />
    <div v-show="showENC">
      <div class="wrap aboutTxt" ref="note" id="note">
        <div
          class="pageTitle wow animate__slideInUp"
          :class="{ titleEn: lang == 'en' }"
        >
          <h2>企业文化</h2>
          <p>CORPORATE CULTURE</p>
        </div>

        <ul class="aboutUl wow animate__slideInUp">
          <li>
            <h3>{{ cultureObj.Title1 }}</h3>
            <h4>{{ cultureObj.CultureInfo1.Item1 }}</h4>
            <p>{{ cultureObj.CultureInfo1.Item2 }}</p>
          </li>
          <li>
            <h3>{{ cultureObj.Title2 }}</h3>
            <h4>{{ cultureObj.CultureInfo2.Item1 }}</h4>
            <p>{{ cultureObj.CultureInfo2.Item2 }}</p>
          </li>
        </ul>
        <div class="aboutOth wow animate__slideInUp">
          <h3>{{ cultureObj.Title3 }}</h3>
          <h4>{{ cultureObj.SubTitle3 }}</h4>
          <ul class="aboutUlIcon">
            <li :key="idx" v-for="(item, idx) in cultureObj.CultureInfo3">
              <span class="icon" :class="`iconImg${idx == 0 ? '' : idx + 1}`"
                >图片</span
              >
              <div>
                <h3>{{ item.Item1 }}</h3>
                <p>{{ item.Item2 }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="wrap aboutBBox wow animate__slideInUp">
        <div class="fullBox">
          <h4>{{ CulturePicInfo.Title }}</h4>
          <p>{{ CulturePicInfo.SubTitle }}</p>
        </div>
        <el-image
          :src="CulturePicInfo.PicUrl"
          fit="contain"
          class="aboutB"
        ></el-image>
      </div>

      <div
        class="company wow animate__slideInUp"
        :class="{ titleEn: lang == 'en' }"
      >
      <div class="wrap">
        <div class="company_tit">{{ company_tit }}</div>
        <div class="company_cont" v-html="company_cont"></div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "./Menu.vue";
import countTo from "vue-count-to";
import { WOW } from "wowjs";
import { changeText } from "@/utils/tool";
import Banner from "@/views/components/Banner";
import cookie from "cookiejs";

export default {
  name: "about",
  data() {
    return {
      type: this.$route.query.type || "",
      animate: false,
      classObject: {
        animate__animated: this.animate,
        animate__flipInX: this.animate,
      },
      startVal: 0,
      endVal: 100,
      autoplay: false,
      Summary: "",
      PicUrl: "",
      CompanyDatas: [],
      refName: ["one", "two", "three", "four"],
      CulturePicInfo: {
        PicUrl: "",
      },
      cultureObj: {
        CultureInfo1: {},
        CultureInfo2: {},
        CultureInfo3: {},
      },
      lang: "zh",
      showENO: true,
      showENC: true,
      company_tit: "",
      company_cont: "",
    };
  },
  components: {
    Menu,
    countTo,
    Banner,
  },
  methods: {
    changeValue(value) {
      return changeText(value);
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // let offsetTop = document.querySelector("#num").offsetTop;
      if (this.$refs.num) {
        let numOffsetTop = this.$refs.num.offsetTop;
        if (scrollTop >= numOffsetTop - 600 && this.autoplay == false) {
          // this.animate = true;
          this.$refs.one0[0].start();
          this.$refs.one1[0].start();
          this.$refs.one2[0].start();
          this.$refs.one3[0].start();
          this.autoplay = true;
        }
      }
    },
    handleScroll2() {
      let note = parseInt(this.$refs.note.offsetTop);
      let meshine = navigator.userAgent;
      var element =
        meshine.indexOf("Weixin") == -1
          ? document.documentElement
          : document.body;

      element.scrollTop = note - 60;
    },
    changeShow() {
      if (this.lang == "en") {
        if (this.type == "my") {
          this.showENC = false;
          this.showENO = true;
        }
        if (this.type == "culture") {
          this.showENO = false;
          this.showENC = true;
        }
      }
    },
  },
  created() {
    this.lang = cookie.get("lang");
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // 对路由变化做出响应...
        this.type = this.$route.params.type;
        if (this.type == "culture") {
          this.handleScroll2();
        }
        this.changeShow();
      }
    );
  },
  mounted() {
    this.type = this.$route.params.type;
    this.changeShow();
    this.$api.about({}).then((res) => {
      const { Summary, PicUrl, CompanyDatas } = res.Value;
      this.Summary = Summary;
      this.PicUrl = PicUrl;
      this.CompanyDatas = CompanyDatas;
      this.type = this.$route.params.type;
      new WOW({
        boxClass: "wow",
        animateClass: "animate__animated",
        offset: 100,
        live: false,
      }).init();

      window.addEventListener("scroll", this.handleScroll);

      this.$api.culture().then((res) => {
        const { CulturePicInfo,CompanyImage, ...rest } = res.Value;
        console.log(res.Value, "+++");
        this.CulturePicInfo = CulturePicInfo;
        this.cultureObj = rest;
        this.company_tit = CompanyImage.Title;
        this.company_cont = CompanyImage.Content;
        if (this.type == "culture") {
          setTimeout(this.handleScroll2(), 5000);
        }
      });
    });
  },
};
</script>

<style lang="scss">
.aboutCom {
  padding-top: 50px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 50px;
  align-items: start;
  p {
    margin: 0 0 40px 0;
    line-height: 25px;
    color: #727171;
  }
}
.aboutNumBox {
  background: #f5f5f5;
  margin-bottom: 20px;
}
.aboutNum {
  display: flex;
  justify-content: space-around;
  width: 1280px;
  margin: 80px auto 0;
  li {
    width: 25%;
    padding: 80px 0;
    align-items: center;
    text-align: center;
    .line {
      border-right: 1px solid #8a8a8a;
    }
    &:last-child {
      .line {
        border: none;
      }
    }
    span {
      display: block;
      strong {
        font-size: 36px;
        font-weight: 200;
        margin-right: 5px;
        display: inline-block;
      }
    }
  }
}
.aboutTxt {
  color: #0b1322;
  .aboutUl {
    margin-top: 50px;
    padding-top: 40px;
    margin-bottom: 40px;
    border: 1px solid #8a8a8a;
    border-right: none;
    border-left: none;
  }
  li {
    h3 {
      font-size: 24px;
      font-weight: 500;
      margin: 0 0 20px 0;
      padding: 0;
    }
    h4 {
      font-size: 26px;
      font-weight: 200;
      margin: 0;
      padding: 0;
    }
  }
  p {
    margin: 0;
    padding: 0;
  }
  li {
    margin-bottom: 50px;
  }
  .aboutOth {
    h3 {
      font-size: 24px;
      font-weight: 500;
      margin: 0 0 20px 0;
      padding: 0;
    }
    h4 {
      font-size: 26px;
      font-weight: 200;
      margin: 0;
      padding: 0;
    }
  }
}
.aboutUlIcon {
  margin-top: 30px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 30px;
  li {
    display: grid;
    grid-template-columns: 120px auto;
    h3 {
      // font-weight: 300 !important;
    }
    .icon {
      transition: all 0.3s;
      width: 100px;
      height: 100px;
      overflow: hidden;
      border: 1px solid #ddd;
      border-radius: 50%;
      text-indent: -1000px;
    }
    &:hover {
      .icon {
        animation: pulse;
        animation-duration: 1s;
      }
      .iconImg {
        background: #ff0000 url("~@/assets/images/iconW.png") center center
          no-repeat;
        background-size: contain;
      }
      .iconImg2 {
        background: #ff0000 url("~@/assets/images/icon2W.png") center center
          no-repeat;
        background-size: contain;
      }
      .iconImg3 {
        background: #ff0000 url("~@/assets/images/icon3W.png") center center
          no-repeat;
        background-size: contain;
      }
      .iconImg4 {
        background: #ff0000 url("~@/assets/images/icon4W.png") center center
          no-repeat;
        background-size: contain;
      }
    }

    .iconImg {
      background: url("~@/assets/images/icon.png") center center no-repeat;
      background-size: contain;
    }
    .iconImg2 {
      background: url("~@/assets/images/icon2.png") center center no-repeat;
      background-size: contain;
    }
    .iconImg3 {
      background: url("~@/assets/images/icon3.png") center center no-repeat;
      background-size: contain;
    }
    .iconImg4 {
      background: url("~@/assets/images/icon4.png") center center no-repeat;
      background-size: contain;
    }
  }
}
.aboutBBox {
  position: relative;
  color: #fff;
  h4 {
    font-weight: 500 !important;
    padding-bottom: 20px;
  }
  h4,
  p {
    text-align: center;
    width: 100%;
    color: #fff;
    z-index: 9;
    font-weight: 200;
    font-size: 24px;
    text-align: center;
  }
  p {
    font-size: 28px;
    top: 45%;
  }
}
.aboutB {
  margin-bottom: 40px;
}
.code {
  margin-bottom: 10px;
}
.fullBox {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.company{
  padding:30px 0;
  .company_tit{
    text-align: center;
    font-size:24px;
    font-weight: bold;
    margin-bottom:35px;
  }
  .company_cont{
    line-height:1.4;
    font-size:16px;
    img{
      max-width:100%;
      height:auto;
    }
  }
}
</style>
